import React, {useState} from "react";
import VerifyLayout from "./verify";
import { Table, Button, Modal } from "react-bootstrap";
import green from "../../assets/images/profile/green.svg";
import { Link } from "react-router-dom";
import nexticon from "../../assets/images/profile/arrow.svg";
import previcon from "../../assets/images/profile/arrow.svg";


const VerifyRoulette = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const item1 = 10;
    return (
        <VerifyLayout>
                <div className="verify-content">

                    <h2>ROULETTE TECHNICAL DETAILS</h2>

                    <p>This game uses two ingredients:</p>

                    <ul>
                    <li><b>Server Seed</b> - provided by us </li>
                    <li><b>Client Seed</b> - the hash for ethereum block #12818935 </li>
                    </ul>

                    <p>We take a Server Seed and hash it (SHA256), creating a new Server Seed. Then we take that Server Seed and hash that too. We repeat this process until we have 2 million hashes -- 2 million server seeds. The very first game of roulette uses the 2 millionth server seed (7ffedb09e12fb4944864c500ab7bac11820ab72acb4022521c78dd2a7c639424), and each game after that works backwards down the list of server seeds. Second game uses the 1,999,999th hash and so on and so forth.</p>

                    <p>The Client Seed is 0xc5cb8288d83903d28f8d727df2cb98e4d4b5f9ebc9fde918a80d0ca199fe451a, which is the hash to ethereum block #12818935. We committed to this block before it was mined and we created all the server seed hashes before committing to this block. This ensures that we could not control the outcome of each game.</p>

                    <p>To verify this, you can input the Server Seed to your game in the code below, and you should see the server seeds and game results for the previous 100 games.</p>

                    <div className="verify-iframe">

                        {/* <img src={iframe} alt="" /> */}
                        <iframe src="https://dotnetfiddle.net/Widget/944Dqf" title="Roulette"></iframe>

                    </div>
                    
                    <Button onClick={handleShow} >ROULETTE SEEDS</Button>
                </div>



                
                <Modal show={show} onHide={handleClose} dialogClassName="history-popup" centered>
              <Modal.Header closeButton>
                <Modal.Title>Roulette History</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <div className="history-popup-content">

              <Table striped bordered variant="dark" responsive>
              <thead>
                <tr>
                <th>Server Seed</th>
                    <th>Time</th>
                    <th>Public Seed </th>
                    <th>Result</th>
                    <th>Verify</th>
                </tr>
              </thead>
              <tbody>

              {[...Array(item1)].map((index) => (
                <tr key={index}>
                  <td>0f8eb2b3ee986a63b4b0725e78d9f9a308490f7ad07a6f271bbac244ba62f927</td>
                  <td>4:09 PM</td>
                  <td>100633302</td>
                  <td><div className="result-value"><img src={green} alt="" /> Green</div></td>
                  <td><Link to="/overview" className="verify-btn">VERIFY</Link></td>
                </tr>
                ))}
              

              </tbody>
              </Table>


              <div className="pagination">

                <Button className="disabled"><img src={previcon} alt="" /> Previous Page</Button>

                <Button>Next Page <img src={nexticon} alt="" /></Button>
                </div>

              </div>
              </Modal.Body>
            </Modal>
        </VerifyLayout>

    );
};

export default VerifyRoulette;